import {BaseClient} from '../utils/base-client';

export class DataDefinitionsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    const baseUrl = workspaceId ? `api/app/workspaces/${workspaceId}` : `api/app/projects/${projectId}`;
    return `${baseUrl}/data-definitions`;
  }

  processResponse(response, _params) {
    return response.results;
  }
}
